import clsx from 'clsx'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'
import notificationLogo from '../../../images/notificationLogo.svg'
import {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {GET_USER_PROFILE} from '../../../../utils/GraphQLAPI'
import {useLazyQuery} from '@apollo/client'
import {BASE_URL} from '../../../../utils/config'
import {useNavigate} from 'react-router-dom'

const itemClass = 'ms-1 ms-lg-3'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'

const Navbar = () => {
  const {config} = useLayout()

  const getUserParams = useParams()
  const [data, setData] = useState<any>('')
  const navigate = useNavigate()

  // Fetch User Profile Data
  const [getUserProfile, {loading: reload}] = useLazyQuery(GET_USER_PROFILE, {
    fetchPolicy: 'network-only',
    variables: {
      getEntityName: true,
    },
    onCompleted: async (userData) => {
      window.localStorage.setItem('userId', JSON.stringify(userData?.getUserProfile?.id))
      setData(userData.getUserProfile)
    },
    onError: () => {
      navigate(`/${getUserParams.adminUser}/login`, {replace: true})
    },
  })

  useEffect(() => {
    getUserProfile()
  }, [])

  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <div className='text-bold d-none d-md-block p-2'>
          Hi, {data.firstName} {data.lastName}
        </div>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <div className='symbol symbol-50px'>
            <div
              className='symbol-label fs-2 fw-bold text-success bg-light-success'
              style={
                data.avatarUrl !== null
                  ? {
                      backgroundImage: `url(${
                        process.env.REACT_APP_IMAGE_BASE_URL + data.avatarUrl
                      })`,
                    }
                  : {}
              }
            >
              <span className='text-capitalize'>
                {data.avatarUrl === null && data.firstName
                  ? data?.firstName?.charAt(0)
                  : data.firstName == null
                  ? data?.emailId?.charAt(0)
                  : ''}
              </span>
            </div>
          </div>
        </div>
        <HeaderUserMenu userInfo={data} />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export {Navbar}
